<template>
  <div>
<!--    <div v-if="tab === POPUP_DETAIL_TAB_INDEX.TASK">-->
<!--      <BlendedTutorTaskTab type-screen="tutor" :curriculumId="selectedProgramId" :lms-core-user-id="selectedStudent.lms_core_user_id"></BlendedTutorTaskTab>-->
<!--    </div>-->
    <v-simple-table
      class="table-layout"
      id="style-2"
      style="overflow-y: auto; max-height: 570px">
      <template v-if="tab === POPUP_DETAIL_TAB_INDEX.EXCHANGE">
        <thead>
        <tr>
          <th v-show="showSTT">#</th>
          <th style="padding-left: 38px;width: 155px">Người thực hiện</th>
          <th v-if="tab == 10">Đơn hàng</th>
          <th style="padding-left: 38px; width: 150px">Thời gian</th>
          <th style="padding-left: 50px;">Mô tả</th>
          <th style="width: 70px" >Thao tác</th>
        </tr>
        </thead>
        <tbody v-if="contactNoteHistories && contactNoteHistories.length">
        <tr
          v-for="(contactHistory, index) in contactNoteHistories"
          :key="contactHistory.id"
          @click="editAppointment(contactHistory)"
          style="cursor: pointer"
        >
          <td v-show="showSTT">{{ index + 1 }}</td>
          <td>{{ _.get(contactHistory, "creator.fullName", "") }}</td>
          <td v-if="tab == 10">
            {{ _.get(contactHistory, "order.getfly_id", "") }}
          </td>
          <td>
            {{ formatDate(_.get(contactHistory, "createdAt", "")) }}
            {{ formatHour(_.get(contactHistory, "createdAt", "")) }}
          </td>
          <td>
              <span v-if="!contactNoteHistories[index].editable" > {{
                  _.get(contactHistory, "description", "")
                }}</span>
            <textarea
              v-else
              v-model="contactHistory.description"
              @change="updateContactHistory(contactHistory,index)"
              style="
                  width: 100%;
                  height: 80%;
                  margin-top: 10px;
                  padding-left: 5px;
                "
            ></textarea>
          </td>
          <td v-if="tab === POPUP_DETAIL_TAB_INDEX.EXCHANGE">
            <div class="d-flex justify-space-around">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    size="16"
                    width="20"
                    height="20"
                    class="mr-1"
                    icon
                    small
                    color="primary"
                    v-on="on"
                    @click="showEditForm(contactHistory, index)"
                  >
                    <v-icon size="16">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Sửa</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :style="
                        checkContactHistory(contactHistory) ? 'display: none' : ''
                      "
                    size="16"
                    width="20"
                    height="20"
                    class="mr-1"
                    icon
                    small
                    color="error"
                    @click="deleteContactHistory(contactHistory)"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Xóa lịch sử</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr><td colspan="4" class="text-center"><span style="color: red">Chưa có dữ liệu</span></td></tr>
        </tbody>
      </template>
      <template v-if="tab === POPUP_DETAIL_TAB_INDEX.LOGS" v-slot:default>
        <thead>
        <tr>
          <th v-show="showSTT">#</th>
          <th style="min-width: 120px">Người thực hiện</th>
          <th v-if="tab == 10">Đơn hàng</th>
          <th style="padding-left: 38px; min-width: 146px">Thời gian</th>
          <th style="padding-left: 124px;">Mô tả</th>
        </tr>
        </thead>
        <tbody v-if="contactHistories && contactHistories.length">
        <tr
          v-for="(contactHistory, index) in contactHistories"
          :key="contactHistory.id"
          @click="editAppointment(contactHistory)"
          style="cursor: pointer"
        >
          <td v-show="showSTT">{{ index + 1 }}</td>
          <td style="font-size: 12px">{{ _.get(contactHistory, "creator.fullName", "") }}</td>
          <td v-if="tab == 10">
            {{ _.get(contactHistory, "order.getfly_id", "") }}
          </td>
          <td style="font-size: 12px">
            {{ formatDateCus(_.get(contactHistory, "createdAt", ""), 'YYYY-MM-DD') }}
            {{ formatHour(_.get(contactHistory, "createdAt", "")) }}
          </td>
          <td>
            <span style="font-size: 12px" v-if="!contactHistories[index].editable" v-html="contactHistory.description || ''"></span>
            <textarea
              v-else
              v-model="contactHistory.description"
              @change="updateContactHistory(contactHistory)"
              style="
                width: 100%;
                height: 80%;
                margin-top: 10px;
                padding-left: 5px;
              "
            ></textarea>
          </td>
          <td v-if="tab == POPUP_DETAIL_TAB_INDEX.CARE">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  size="16"
                  width="20"
                  height="20"
                  class="mr-1"
                  icon
                  small
                  color="primary"
                  v-on="on"
                  @click="showEditForm(contactHistory, index)"
                >
                  <v-icon size="16">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Sửa</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :style="
                    checkContactHistory(contactHistory) ? 'display: none' : ''
                  "
                  size="16"
                  width="20"
                  height="20"
                  class="mr-1"
                  icon
                  small
                  color="error"
                  @click="deleteContactHistory(contactHistory)"
                  v-on="on"
                >
                  <v-icon size="16">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Xóa lịch sử</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr><td colspan="4" class="text-center"><span style="color: red">Chưa có dữ liệu</span></td></tr>
        </tbody>
      </template>
      <div v-if="tab === POPUP_DETAIL_TAB_INDEX.ORDER">
        <div class="pt-3">
          <OrderHistory
            projectName="CRM"
            :totalListOrder="totalListOrder"
            :urlCRM="urlCRM"
            :urlERP="urlERP"
            :urlOMS="urlOMS"
            @redirectOrder="handleRedirectOrder($event)"
            @toOrderDetail="toOrderDetail($event)"
            @openDetailOrder="openDetailOrder($event)"
            @openDetailOrderGroup="openDetailOrderGroup($event)"
          />
        </div>
      </div>
      <div v-if="tab === POPUP_DETAIL_TAB_INDEX.STUDY_HISTORY">
        <div class="study-history" >
          <p class="table-title">BUỔI HỌC TIẾP THEO</p>
          <table style="width: 100%">
            <thead>
            <tr>
              <th style="width: 155px">Thời gian</th>
              <th>Bài học</th>
              <th>Lớp</th>
            </tr>
            </thead>
            <tbody v-if="lessonByStudent && lessonByStudent.length">
            <tr v-for="(item, index) in lessonByStudent"  :key="index">
              <td style="font-weight: 500;">{{ getFormatDateLessonHistory(item.lesson_start_time) }}</td>
              <td>{{ item.lesson_title }}</td>
              <td>{{ item.class_name }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr><td colspan="3" class="text-center" style="color:red">Chưa có dữ liệu buổi học</td></tr>
            </tbody>
          </table>
        </div>
        <div class="study-history-tab" v-if="false">
          <div> <v-tabs
            v-model="tabStudyHistory"
          >
            <v-tabs-slider color="#1976d2"></v-tabs-slider>

            <v-tab>BUỔI ĐÃ HỌC</v-tab>
            <v-tab>THỐNG KÊ TỔNG QUAN</v-tab>
          </v-tabs></div>
          <div class="care-tab-items-view">
            <v-tabs-items v-model="tabStudyHistory">
              <v-tab-item style="margin-top: 16px">
                <div id="style-2" style="height: 310px; overflow-y: auto; overflow-x: hidden; padding-top: 10px">
                  <div >
                    <div v-for="index in 5" :key="index" class="item-study-history">
                      <v-row style="padding: 5px">
                        <v-col style="max-width: 180px; max-height: 72px">
                          <p class="class-and-call-type">TOAN.0123</p>
                          <p class="history-care-created-at">20:00 T5 02.07.2022</p>
                        </v-col>
                        <v-col style="padding-left: 0px;">
                          <p class="lesson-name">Đồ thị hàm số lượng giác</p>
                          <div class="template">
                            <v-row>
                              <div class="student-stat" style="margin-left: 0px !important;">
                                <v-row>
                                  <v-col style="max-width: 26px">
                                    <div class="frame-icon"><img src="../assets/Frame.png" style="padding-top: 2px;"></div>
                                  </v-col>
                                  <v-col>
                                    <p class="title-student-stat">Điểm danh</p>
                                    <p class="title-student-stat-result">Học 20p</p>
                                    <div style="position: relative; bottom: 49px; left: 36px;"><v-icon :color="false ? '#27AE60' : '#EB5757'" size="14">{{false ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon></div>
                                  </v-col>
                                </v-row>
                              </div>
                              <div class="student-stat">
                                <v-row>
                                  <v-col style="max-width: 26px">
                                    <div class="frame-icon"><img src="../assets/Frame.png" style="padding-top: 2px;"></div>
                                  </v-col>
                                  <v-col>
                                    <p class="title-student-stat">Nhận cúp</p>
                                    <p class="title-student-stat-result">12 Cúp</p>
                                    <div style="position: relative; bottom: 49px; left: 36px;"><v-icon :color="true ? '#27AE60' : '#EB5757'" size="14">{{true ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon></div>
                                  </v-col>
                                </v-row>
                              </div>
                              <div class="student-stat">
                                <v-row>
                                  <v-col style="max-width: 26px">
                                    <div class="frame-icon"><img src="../assets/Frame.png" style="padding-top: 2px;"></div>
                                  </v-col>
                                  <v-col>
                                    <p class="title-student-stat">Bài tập về nhà</p>
                                    <p class="title-student-stat-result">8 điểm</p>
                                    <div style="position: relative; bottom: 49px; left: 36px;"><v-icon :color="true ? '#27AE60' : '#EB5757'" size="14">{{true ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon></div>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item></v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
      <!-- <v-dialog
        v-model="pickTest"
        persistent
        max-width="600px"
        :retain-focus="false"
      >
        <PickTest
          :contact="contactQuickviewDetail"
          @close="pickTest = false"
          :book="book"
        />
      </v-dialog> -->
      <!-- <v-dialog v-model="pickDate" max-width="900"  :retain-focus="false"  @click:outside="closeDialog">
        <PickDatePopup :interviewDetailId="interviewDetailId" :isCancel="isCancel" :contacts="contactQuickviewDetail" :book="book" />
      </v-dialog> -->
      <modal-edit-comment
        :isEditComment="isEditComment"
        @closeModalEditComment="closeModalEditComment"
        :itemReview="itemReview"
        :subjectId="selectedStudent.subject_id"
      />
      <modal-share-comment
        :isShareComment="isShareComment"
        @closeModalShareComment="closeModalShareComment"
        :itemReview="itemReview"
        :subjectId="selectedStudent.subject_id"
      />
      <modal-periodic
        :isPopupPeriodic="isPopupPeriodic"
        @closeModalPeriodic="isPopupPeriodic = false"
        :periodics="periodics"
        :homeworkHeaders="checkSubjectOfStudent(selectedSubjectId, selectedProgramId)"
      />
      <v-dialog
        v-model="periodicModalIeltY"
        v-if="periodicModalIeltY"
        persistent
        max-width="1200"
        :retain-focus="false"
      >
        <ModalPeriodicIeltY
          :lmsCoreUserID="lmsCoreUserID"
          :selectedSubjectId="selectedSubjectId"
          :selectedProgramId="selectedProgramId"
          @close="periodicModalIeltY = false"
        />
      </v-dialog>
      <modal-practice-homework
        @openInNewTab="openInNewTab"
      />
    </v-simple-table>
    <div v-if="tab === POPUP_DETAIL_TAB_INDEX.CARE">
      <div class="care-form">
        <v-row style="gap: 9px"><p class="care-form-title">{{ selectedStudent.type_customer_care === TYPE_CALL_STATUS.C0 || selectedStudent.type_customer_care === TYPE_CALL_STATUS.CHAM_SOC_DINH_KY ? 'CHĂM SÓC ĐỊNH KỲ' : 'GIA HẠN'}}: {{ getSubjectById(selectedStudent.subject_id).name }}</p>
          <div
            class="list-status-history" :style="generateCss(mapCallStatus && mapCallStatus[selectedStudent.call_status_id] ? mapCallStatus[selectedStudent.call_status_id].color : '')"
          >
            <span class="m-auto">{{ mapCallStatus && mapCallStatus[selectedStudent.call_status_id] ? mapCallStatus[selectedStudent.call_status_id].callType : '' }}</span>
          </div>
        </v-row>
        <v-form ref="historyCareForm">
          <v-row style="margin-top: 0px !important;">
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Trạng thái *"
                :items="mapCallTypeIdAndListCallStatus[selectedStudent.call_id]"
                item-text="name"
                item-value="id"
                clearable
                hide-details="auto"
                placeholder="Chọn trạng thái"
                persistent-placeholder
                v-model="formCreateHistoryNote.callStatusId"
                :rules="callStatusRules"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                label="Mô tả *"
                hide-details="auto"
                placeholder="Nhập mô tả"
                persistent-placeholder
                v-model="formCreateHistoryNote.note"
                :rules="descriptionRules"
                @keyup.enter="creatHistoryCareNote()"
              ></v-text-field>
            </v-col>
            <!--              <v-col cols="12" md="1"><v-icon style="transform: rotate(33deg);padding-top: 28px;">mdi-paperclip</v-icon></v-col>-->
          </v-row>
        </v-form>
        <v-row style="justify-content: flex-end">
          <v-btn v-if="filterForm.typeCustomerCare === 2 || ((filterForm.typeCustomerCare === 1 || filterForm.typeCustomerCare === 4) && $store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && checkPermissionCS)" class="transfer-sales-button" depressed :loading="isSubmitting" :disabled="isSubmitting" @click="transferToSaleExtend()">
            Chuyển sale
          </v-btn>
          <v-btn class="update-button" depressed :loading="disableSubmit" :disabled="disableSubmit" @click="creatHistoryCareNote()">
            Cập nhật
          </v-btn>
        </v-row>
        <div class="template">
          <v-row>
            <v-col
              v-if="!isPeriodicIeltYType && isShowPeriodicScore && $route.query.tutorSchoolLevel !== SCHOOL_LEVEL.SECONDARY"
              cols="3" md="3"
              class="student-stat point-click"
              style="margin-left: -8px !important;"
              @click="openPopupKTDK()"
            >
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">KTĐK Tháng {{monthNow}}</p>
                  <p class="title-student-stat-result">{{ scorePeriodic || '0/0' }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="isPeriodicIeltYType && isShowPeriodicScore && $route.query.tutorSchoolLevel !== SCHOOL_LEVEL.SECONDARY"
              cols="3" md="3"
              class="student-stat point-click"
              style="margin-left: -8px !important;"
              @click="openPopupPeriodicIeltY()"
            >
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Kiểm tra
                    <v-tooltip right>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon class="icon-tooltip" v-on="{...tooltip}" small color="#ccc">mdi-information</v-icon>
                      </template>
                      <span>Là điểm kiểm tra mới nhất của tháng hiện tại</span>
                    </v-tooltip>
                  </p>
                  <p class="title-student-stat-result">{{ scorePeriodic || '-' }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="isShowPeriodicScore && $route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY"
              cols="3" md="3"
              class="student-stat point-click"
              style="margin-left: -8px !important;"
              @click="openPopupPeriodicIeltY()"
            >
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">
                    {{SPECIAL_ENGLISH_CODE.includes(_.get(mapProgramIdAndProgram, `[${selectedProgramId}].code`, '')) ? `KTĐK Tháng ${monthNow}` : 'Kiểm tra'}}
                    <v-tooltip right>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon class="icon-tooltip" v-on="{...tooltip}" small color="#ccc">mdi-information</v-icon>
                      </template>
                      <span>Điểm kiểm tra gần nhất</span>
                    </v-tooltip>
                  </p>
                  <p class="title-student-stat-result">{{ scorePeriodic || '-' }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" md="3" class="student-stat" v-if="selectedProgramId !== 0">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Chuyên cần</p>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p class="title-student-stat-result" v-else>
                    {{ attendedStudent.attendedLesson }}/{{ attendedStudent.totalLesson }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" md="3" class="student-stat">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <div class="d-flex align-center">
                    <p class="title-student-stat">Bài tập về nhà
                    </p>
                    <v-tooltip right>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon class="icon-tooltip" v-on="{...tooltip}" small color="#ccc" v-if="selectedProgramId === 0">mdi-information</v-icon>
                      </template>
                      <span>Tổng số bài tập hoàn thành/ Tổng số bài của chương trình tự học</span>
                    </v-tooltip>
                  </div>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p v-else class="title-student-stat-result">{{ ($route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY || $route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) ? scoreHomework : computedScore }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE && selectedProgramId !== 0" cols="3" md="3" class="student-stat" style="margin-right: -8px !important;">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Vào lớp muộn</p>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p v-else class="title-student-stat-result">
                    {{ attendedStudent.late }}/{{ attendedStudent.totalLesson }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="selectedProgramId === 0" cols="3" md="3" class="student-stat">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Số câu đúng/Tổng số câu</p>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p v-else class="title-student-stat-result">
                    {{ computedQuestion }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="selectedProgramId === 0" cols="3" md="3" class="student-stat" style="margin-right: -8px !important;">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Điểm trung bình</p>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p v-else class="title-student-stat-result">
                    {{ averageScore }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <!-- UI report -->
            <v-col v-if="this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY" cols="3" md="3" class="student-stat" style="margin-right: -8px !important;" @click="openModalListComment()">
              <v-row>
                <v-col style="max-width: 26px">
                  <div class="frame-icon"><img src="../assets/Frame.png"></div>
                </v-col>
                <v-col>
                  <p class="title-student-stat">Báo cáo cuối kỳ</p>
                  <v-skeleton-loader class="title-student-stat-result" type="text" max-width="100" v-if="isLoadingRightData">
                  </v-skeleton-loader>
                  <p v-else class="title-student-stat-result" style="max-width: 110px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap">
                    {{this.listComment.length > 0 ? this.listComment[0].name : ''}}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
      <!--Xếp lớp-->
      <div class="care-form mt-4 d-flex align-center justify-center flex-column" style="padding-top: 56px" v-if="isShowSortClassTutor">
        <span style="font-size: 32px !important; font-weight: bold">Thời gian hết hạn xếp lớp: {{showCountdownTime}}</span>
        <v-btn color="#219653" style="color: white; margin-top: 32px" @click="handleSortClass">
          XẾP LỚP
        </v-btn>
      </div>
      <div class="care-form mt-4 d-flex align-center justify-center flex-column" style="padding-top: 56px" v-if="isShowChangeOperatorSection">
        <div style="font-size: 32px !important; font-weight: bold">Đã chuyển vận hành xếp lớp</div>
        <div style="margin-top: 16px">{{_.get(CLASS_ASSIGNMENT_CHANGE_REASON_OPTION.find((e) => e.value === this.reasonType), 'text', '')}} - {{changeOperatorLogTime}}</div>
      </div>
      <!-- Care tab -->
      <div class="care-tab mt-4">
        <div> <v-tabs
          v-model="tabCare"
        >
          <v-tabs-slider color="#1976d2"></v-tabs-slider>

          <v-tab
            v-for="item in itemsCare"
            :key="item.key"
            class="no-uppercase"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs></div>
        <div >
          <v-tabs-items v-model="tabCare">
            <v-tab-item
              v-for="item in itemsCare"
              :key="item.key"
            >
              <v-card flat :style="{marginTop: item.key === 'home-work' ? '0px' : ''}">
                <div v-if="item.key === 'history-care'" id="style-2" style="max-height: 343px; overflow-y: auto; overflow-x: hidden">
                  <div v-if="listHistoryCare && listHistoryCare.length" >
                    <div v-for="(item, index) in listHistoryCare" :key="index" class="item-history-care">
                      <v-row style="width:100%">
                        <v-col cols="12" md='2' style="padding-right:0px" class="d-flex">
                          <div
                            class="list-status-history mx-auto" :style="generateCss(mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : '')" style="margin-top: 3px;"
                          >
                              <span class="m-auto">
                              {{ mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].callType : '' }}
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" style="max-width: 180px; max-height: 72px;padding-left:0px">
                            <p class="class-and-call-type">{{ selectedStudent.type_curriculum === "ielts_course" ? getSubjectById(selectedStudent.subject_id).name : getSubjectById(selectedStudent.subject_id).name }} / <span style="color: #2F80ED;">{{item.created_name ? item.created_name : 'Log hệ thống'}}</span></p>
                            <p class="history-care-created-at">{{ formatDateCustom(item.created_at) }}</p>
                          </v-col>
                          <v-col cols="12" md="6" style="padding-left: 0px;">
                            <p class="history-care-note">{{ item.note }}</p>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                    <div v-else class="d-flex justify-center my-4">
                      <div style="color: red">Chưa có dữ liệu</div>
                    </div>
                  </div>
                  <div v-if="item.key === 'review'" class="review my-3" id="style-2" style="max-height: 343px; overflow-y: auto" :style="$store.state.typeCurriculum != TYPE_CURRICULUM_OBJ.ONLINE ? 'width: 653' : 'width: unset'">
                    <div class="table-container" v-if="$store.state.typeCurriculum != TYPE_CURRICULUM_OBJ.ONLINE">
                      <v-simple-table v-if="listLessonIeltsy && listLessonIeltsy.length" class="custom-table table-container" id="style-2" style="overflow: auto">
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th rowspan="2" class="header-cell sticky-column sticky-top-column" style="width: 150px; left: 0; z-index: 99; background: #F7F7Fc">Buổi học</th>
                            <th class="header-cell text-center p-learning sticky-top-column" colspan="4" style="width: 500px; border-bottom: 1px solid">P-Learning</th>
                            <th rowspan="2" class="header-cell p-learning sticky-top-column" style="width: 304px; z-index: 98;border-bottom: thin solid rgba(0, 0, 0, 0.12);">Nhận xét</th>
                            <th rowspan="2" class="header-cell p-learning sticky-top-column" style="width: 100px; z-index: 80;border-bottom: thin solid rgba(0, 0, 0, 0.12);">Thao tác</th>
                          </tr>
                          <tr>
                            <th class="column-header text-center sticky-top-column" style="width: 150px; top: 48px">Quiz</th>
                            <th class="column-header text-center sticky-top-column" style="width: 150px; top: 48px">Vocab</th>
                            <th class="column-header text-center sticky-top-column" style="width: 150px; top: 48px">Grammar</th>
                            <th class="column-header text-center sticky-top-column" style="width: 150px; top: 48px">Duet</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(student, index) in listLessonIeltsy" :key="index">
                            <td class="data-cell" style="position: sticky; left: 0; z-index: 9; background: #F7F7Fc">
                              <b style="font-weight: 600;">{{student.class_code}}</b>
                              <div style="color: #9B9B9B">{{formatDateCustom(student.lesson_start_time)}}</div>
                            </td>
                            <!--Quiz-->
                            <td class="data-cell text-center">
                              <template v-if="student.skills['1']">
                                <v-icon :class="statusColor[student.skills['1'].status]">mdi-circle-medium</v-icon>
                                <!--                                    <a href="#" target="_blank" style="color: #1E90FF"><span v-if="student.skills['1'].correct_question">{{student.skills['1'].correct_question}}/{{student.skills['1'].total_question}}</span></a>-->
                                <a v-if="student.skills['1'].reference_link" :href="student.skills['1'].reference_link" target="_blank" style="color: #1E90FF"><span v-if="student.skills['1'].correct_question">{{student.skills['1'].correct_question}}/{{student.skills['1'].total_question}}</span></a>
                                <span v-if="!student.skills['1'].reference_link"><span v-if="student.skills['1'].correct_question">{{student.skills['1'].correct_question}}/{{student.skills['1'].total_question}}</span></span>
                                <div class="d-flex align-center justify-center" v-if="student.skills['1'].no_of_cup">
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_224_414)">
                                      <path
                                        d="M10.156 6.73692C10.0206 6.7732 9.88141 6.69285 9.84514 6.55747C9.80886 6.42209 9.88921 6.28292 10.0246 6.24665C11.3773 5.88247 12.18 4.49213 11.8191 3.13857L11.2936 1.17756L9.08746 1.76869C8.95208 1.80497 8.81291 1.72462 8.77664 1.58924C8.74037 1.45386 8.82071 1.3147 8.95609 1.27842L11.4074 0.621603C11.5428 0.585328 11.6819 0.665675 11.7182 0.801054L12.3093 3.0072C12.7425 4.63148 11.7792 6.29994 10.156 6.73692Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M4.763 8.1819C3.13872 8.61511 1.47026 7.65182 1.03328 6.02855L0.442149 3.82241C0.405874 3.68703 0.486221 3.54786 0.6216 3.51159L3.07286 2.85477C3.20824 2.8185 3.3474 2.89885 3.38368 3.03422C3.41995 3.1696 3.33961 3.30877 3.20423 3.34504L0.99808 3.93618L1.52353 5.89719C1.88773 7.24988 3.27807 8.05259 4.63163 7.69166C4.76701 7.65538 4.90618 7.73573 4.94245 7.87111C4.9787 8.00647 4.89838 8.14563 4.763 8.1819Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M10.0341 10.9354L9.86592 10.8354C9.21053 10.4446 8.67341 9.00477 8.52207 8.48308C8.48364 8.35032 8.34606 8.27275 8.21257 8.30854L7.23205 8.57127C7.09873 8.60697 7.01838 8.74264 7.05115 8.87669C7.18142 9.40403 7.43589 10.9185 7.06348 11.5858L6.96785 11.7564C6.48034 12.6295 6.12421 13.2614 6.27383 13.8198C6.31011 13.9552 6.44927 14.0356 6.58465 13.9993L11.4872 12.6857C11.6226 12.6494 11.7029 12.5102 11.6666 12.3748C11.517 11.8164 10.8927 11.4472 10.0341 10.9354Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M8.82449 0.788191L2.94142 2.36455C2.80604 2.40083 2.7257 2.53999 2.76197 2.67537L3.81288 6.59742C4.30486 8.34159 6.0969 9.37622 7.85341 8.9302C9.5976 8.43821 10.6322 6.64618 10.1862 4.88967L9.1353 0.967643C9.09903 0.832264 8.95987 0.751917 8.82449 0.788191Z"
                                        fill="#FFC107"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_224_414">
                                        <rect width="12.1812" height="12.1812" fill="white"
                                              transform="translate(0 3.15271) rotate(-15)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span v-if="student.skills['1'].no_of_cup">x {{student.skills['1'].no_of_cup}}</span>
                                </div>
                              </template>
                            </td>
                            <!--Grammar-->
                            <td class="data-cell text-center">
                              <template v-if="student.skills['2']">
                                <v-icon :class="statusColor[student.skills['2'].status]">mdi-circle-medium</v-icon>
                                <a v-if="student.skills['2'].reference_link" :href="student.skills['2'].reference_link" target="_blank" style="color: #1E90FF"><span v-if="student.skills['2'].correct_question">{{student.skills['2'].correct_question}}/{{student.skills['2'].total_question}}</span></a>
                                <span v-if="!student.skills['2'].reference_link"><span v-if="student.skills['2'].correct_question">{{student.skills['2'].correct_question}}/{{student.skills['2'].total_question}}</span></span>
                                <div class="d-flex align-center justify-center" v-if="student.skills['2'].no_of_cup">
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_224_414)">
                                      <path
                                        d="M10.156 6.73692C10.0206 6.7732 9.88141 6.69285 9.84514 6.55747C9.80886 6.42209 9.88921 6.28292 10.0246 6.24665C11.3773 5.88247 12.18 4.49213 11.8191 3.13857L11.2936 1.17756L9.08746 1.76869C8.95208 1.80497 8.81291 1.72462 8.77664 1.58924C8.74037 1.45386 8.82071 1.3147 8.95609 1.27842L11.4074 0.621603C11.5428 0.585328 11.6819 0.665675 11.7182 0.801054L12.3093 3.0072C12.7425 4.63148 11.7792 6.29994 10.156 6.73692Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M4.763 8.1819C3.13872 8.61511 1.47026 7.65182 1.03328 6.02855L0.442149 3.82241C0.405874 3.68703 0.486221 3.54786 0.6216 3.51159L3.07286 2.85477C3.20824 2.8185 3.3474 2.89885 3.38368 3.03422C3.41995 3.1696 3.33961 3.30877 3.20423 3.34504L0.99808 3.93618L1.52353 5.89719C1.88773 7.24988 3.27807 8.05259 4.63163 7.69166C4.76701 7.65538 4.90618 7.73573 4.94245 7.87111C4.9787 8.00647 4.89838 8.14563 4.763 8.1819Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M10.0341 10.9354L9.86592 10.8354C9.21053 10.4446 8.67341 9.00477 8.52207 8.48308C8.48364 8.35032 8.34606 8.27275 8.21257 8.30854L7.23205 8.57127C7.09873 8.60697 7.01838 8.74264 7.05115 8.87669C7.18142 9.40403 7.43589 10.9185 7.06348 11.5858L6.96785 11.7564C6.48034 12.6295 6.12421 13.2614 6.27383 13.8198C6.31011 13.9552 6.44927 14.0356 6.58465 13.9993L11.4872 12.6857C11.6226 12.6494 11.7029 12.5102 11.6666 12.3748C11.517 11.8164 10.8927 11.4472 10.0341 10.9354Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M8.82449 0.788191L2.94142 2.36455C2.80604 2.40083 2.7257 2.53999 2.76197 2.67537L3.81288 6.59742C4.30486 8.34159 6.0969 9.37622 7.85341 8.9302C9.5976 8.43821 10.6322 6.64618 10.1862 4.88967L9.1353 0.967643C9.09903 0.832264 8.95987 0.751917 8.82449 0.788191Z"
                                        fill="#FFC107"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_224_414">
                                        <rect width="12.1812" height="12.1812" fill="white"
                                              transform="translate(0 3.15271) rotate(-15)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span v-if="student.skills['2'].no_of_cup">x {{student.skills['2'].no_of_cup}}</span>
                                </div>
                              </template>
                            </td>
                            <!--                Quiz-->
                            <td class="data-cell text-center">
                              <template v-if="student.skills['3']">
                                <v-icon :class="statusColor[student.skills['3'].status]">mdi-circle-medium</v-icon>
                                <!--                                    <a href="#" target="_blank" style="color: #1E90FF"><span v-if="student.skills['3'].correct_question">{{student.skills['3'].correct_question}}/{{student.skills['3'].total_question}}</span></a>-->
                                <a v-if="student.skills['3'].reference_link" :href="student.skills['3'].reference_link" target="_blank" style="color: #1E90FF"><span v-if="student.skills['3'].correct_question">{{student.skills['3'].correct_question}}/{{student.skills['3'].total_question}}</span></a>
                                <span v-if="!student.skills['3'].reference_link"><span v-if="student.skills['3'].correct_question">{{student.skills['3'].correct_question}}/{{student.skills['3'].total_question}}</span></span>
                                <div class="d-flex align-center justify-center" v-if="student.skills['3'].no_of_cup">
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_224_414)">
                                      <path
                                        d="M10.156 6.73692C10.0206 6.7732 9.88141 6.69285 9.84514 6.55747C9.80886 6.42209 9.88921 6.28292 10.0246 6.24665C11.3773 5.88247 12.18 4.49213 11.8191 3.13857L11.2936 1.17756L9.08746 1.76869C8.95208 1.80497 8.81291 1.72462 8.77664 1.58924C8.74037 1.45386 8.82071 1.3147 8.95609 1.27842L11.4074 0.621603C11.5428 0.585328 11.6819 0.665675 11.7182 0.801054L12.3093 3.0072C12.7425 4.63148 11.7792 6.29994 10.156 6.73692Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M4.763 8.1819C3.13872 8.61511 1.47026 7.65182 1.03328 6.02855L0.442149 3.82241C0.405874 3.68703 0.486221 3.54786 0.6216 3.51159L3.07286 2.85477C3.20824 2.8185 3.3474 2.89885 3.38368 3.03422C3.41995 3.1696 3.33961 3.30877 3.20423 3.34504L0.99808 3.93618L1.52353 5.89719C1.88773 7.24988 3.27807 8.05259 4.63163 7.69166C4.76701 7.65538 4.90618 7.73573 4.94245 7.87111C4.9787 8.00647 4.89838 8.14563 4.763 8.1819Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M10.0341 10.9354L9.86592 10.8354C9.21053 10.4446 8.67341 9.00477 8.52207 8.48308C8.48364 8.35032 8.34606 8.27275 8.21257 8.30854L7.23205 8.57127C7.09873 8.60697 7.01838 8.74264 7.05115 8.87669C7.18142 9.40403 7.43589 10.9185 7.06348 11.5858L6.96785 11.7564C6.48034 12.6295 6.12421 13.2614 6.27383 13.8198C6.31011 13.9552 6.44927 14.0356 6.58465 13.9993L11.4872 12.6857C11.6226 12.6494 11.7029 12.5102 11.6666 12.3748C11.517 11.8164 10.8927 11.4472 10.0341 10.9354Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M8.82449 0.788191L2.94142 2.36455C2.80604 2.40083 2.7257 2.53999 2.76197 2.67537L3.81288 6.59742C4.30486 8.34159 6.0969 9.37622 7.85341 8.9302C9.5976 8.43821 10.6322 6.64618 10.1862 4.88967L9.1353 0.967643C9.09903 0.832264 8.95987 0.751917 8.82449 0.788191Z"
                                        fill="#FFC107"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_224_414">
                                        <rect width="12.1812" height="12.1812" fill="white"
                                              transform="translate(0 3.15271) rotate(-15)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span v-if="student.skills['3'].no_of_cup">x {{student.skills['3'].no_of_cup}}</span>
                                </div>
                              </template>
                            </td>
                            <!--duet-->
                            <td class="data-cell text-center">
                              <template v-if="student.skills['4']">
                                <v-icon :class="statusColor[student.skills['4'].status]">mdi-circle-medium</v-icon>
                                <div class="d-flex align-center flex-column">
                                  <div class="mr-1" :style="[student.skills['4'].correct_question > 80 ? {'color': 'green'} : student.skills['4'].correct_question < 70 ? {'color': 'red'} : {'color': 'orange'}]" style="color: green" v-if="student.skills['4'].correct_question">{{student.skills['4'].correct_question}}%</div>
                                  <a v-if="student.skills['4'].reference_link" :href="student.skills['4'].reference_link" target="_blank" style="color: #1E90FF">Link</a>
                                </div>
                                <div class="d-flex align-center justify-center" v-if="student.skills['4'].no_of_cup">
                                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_224_414)">
                                      <path
                                        d="M10.156 6.73692C10.0206 6.7732 9.88141 6.69285 9.84514 6.55747C9.80886 6.42209 9.88921 6.28292 10.0246 6.24665C11.3773 5.88247 12.18 4.49213 11.8191 3.13857L11.2936 1.17756L9.08746 1.76869C8.95208 1.80497 8.81291 1.72462 8.77664 1.58924C8.74037 1.45386 8.82071 1.3147 8.95609 1.27842L11.4074 0.621603C11.5428 0.585328 11.6819 0.665675 11.7182 0.801054L12.3093 3.0072C12.7425 4.63148 11.7792 6.29994 10.156 6.73692Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M4.763 8.1819C3.13872 8.61511 1.47026 7.65182 1.03328 6.02855L0.442149 3.82241C0.405874 3.68703 0.486221 3.54786 0.6216 3.51159L3.07286 2.85477C3.20824 2.8185 3.3474 2.89885 3.38368 3.03422C3.41995 3.1696 3.33961 3.30877 3.20423 3.34504L0.99808 3.93618L1.52353 5.89719C1.88773 7.24988 3.27807 8.05259 4.63163 7.69166C4.76701 7.65538 4.90618 7.73573 4.94245 7.87111C4.9787 8.00647 4.89838 8.14563 4.763 8.1819Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M10.0341 10.9354L9.86592 10.8354C9.21053 10.4446 8.67341 9.00477 8.52207 8.48308C8.48364 8.35032 8.34606 8.27275 8.21257 8.30854L7.23205 8.57127C7.09873 8.60697 7.01838 8.74264 7.05115 8.87669C7.18142 9.40403 7.43589 10.9185 7.06348 11.5858L6.96785 11.7564C6.48034 12.6295 6.12421 13.2614 6.27383 13.8198C6.31011 13.9552 6.44927 14.0356 6.58465 13.9993L11.4872 12.6857C11.6226 12.6494 11.7029 12.5102 11.6666 12.3748C11.517 11.8164 10.8927 11.4472 10.0341 10.9354Z"
                                        fill="#FFA000"/>
                                      <path
                                        d="M8.82449 0.788191L2.94142 2.36455C2.80604 2.40083 2.7257 2.53999 2.76197 2.67537L3.81288 6.59742C4.30486 8.34159 6.0969 9.37622 7.85341 8.9302C9.5976 8.43821 10.6322 6.64618 10.1862 4.88967L9.1353 0.967643C9.09903 0.832264 8.95987 0.751917 8.82449 0.788191Z"
                                        fill="#FFC107"/>
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_224_414">
                                        <rect width="12.1812" height="12.1812" fill="white"
                                              transform="translate(0 3.15271) rotate(-15)"/>
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span v-if="student.skills['4'].no_of_cup">x {{student.skills['4'].no_of_cup}}</span>
                                </div>
                              </template>
                            </td>
                            <!-- Nhận xét-->
                            <td class="data-cell">
                              <div class="d-flex align-center">
                                <div style="white-space: nowrap; font-weight: bold; font-size: 14px;">Thái độ học tập</div>
                                <div>
                                  <v-input class="star-rating" :value="student.care_comment.rating">
                                    <v-rating
                                      color="yellow"
                                      background-color="#E2E2E2"
                                      empty-icon="mdi-star"
                                      full-icon="mdi-star"
                                      hover
                                      readonly
                                      length="5"
                                      size="24"
                                      v-model="student.care_comment.rating"
                                    ></v-rating>
                                  </v-input>
                                </div>
                              </div>
                              <v-text-field v-model="student.care_comment.comment_content" readonly placeholder="Nhận xét học sinh"></v-text-field>
                            </td>
                            <td>
                              <!--fix bug IELTSY-1737-->
                              <div class="d-flex justify-center" v-if="isStationHomeroomTeacher">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn @click="openEditComment(student.care_comment)" width="24" height="24" class="mr-2"  v-on="on" icon color="#FD1F6D">
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Sửa nhận xét</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <!--fix bug IELTSY-1737-->
                                    <v-btn v-if="student.care_comment.publish_status !== 1" @click="openShareComment(student.care_comment)" width="24" height="24" class="mr-2"  v-on="on" icon color="#FD1F6D">
                                      <v-icon>mdi-share-circle </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Chia sẻ nhận xét</span>
                                </v-tooltip>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div v-if="_.isEmpty(listLessonIeltsy)" style="color: red">Không có nhận xét nào!</div>
                    </div>
                    <template v-if="$store.state.typeCurriculum == TYPE_CURRICULUM_OBJ.ONLINE">
                      <div class="review-item">
                        <div class="review-item-name col-md-3 font-weight-bold">Giáo viên </div>
                        <div class="col-md-7 font-weight-bold">Nhận xét</div>
                        <div class="col-md-2 font-weight-bold">Thao tác</div>
                      </div>
                      <div v-if="_.isEmpty(listReviewCare)" style="color: red" class="text-center my-2">Không có nhận xét nào!</div>
                      <div v-for="(item, index) in listReviewCare" :key="index" class="review-item">
                        <div class="review-item-name col-md-3">
                          <div>
                            <b>{{item.teacher_name}}</b><br>
                            <span>{{formatDateCustom(item.created_at)}}</span>
                          </div>
                        </div>
                        <div class="col-md-7">{{item.comment_content}}</div>
                        <div class="col-md-2">
                          <div class="d-flex" v-if="(isTutorHomeroomTeacher && $route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY) || (isTutorHomeroomTeacherSecondary && $route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY)">
                            <v-btn icon color="#E91E63" small @click="openEditComment(item)">
                              <v-icon dark>mdi-pencil</v-icon>
                            </v-btn>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn v-if="item.publish_status !== 1" icon color="#E91E63" small @click="openShareComment(item)" v-on="on">
                                  <v-icon dark>mdi-share</v-icon>
                                </v-btn>
                              </template>
                              <span>Chia sẻ nhận xét</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-if="item.key === 'home-work'" id="style-2" class="my-4">
                    <div v-if="$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY || $route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY" style="width: 100%; overflow-y: auto; overflow-x: hidden; background-color: #F7F7FC !important; padding: 0px 5px 0px 5px">
                    <v-data-table
                      :headers="homeworkHeaders"
                      :items="homeworks"
                      :items-per-page="pagination.rowsPerPage"
                      :page="pagination.page"
                      :server-items-length="pagination.totalItems"
                      class="elevation-1 home-work-list-table custom-table-v2"
                      style="background-color: #F7F7FC"
                      :height="`${isShowSortClassTutor ? 270 : ''}`"
                      fixed-header
                      :options.sync="pagination"
                      disable-sort
                      dense
                      :footer-props="{
                          itemsPerPageOptions : [5,10,15],
                        }"
                      @update:options="paginateHomeWorkTable"
                    >
                      <template v-slot:body="{ items }">
                        <template>
                          <tbody v-for="item in items" :key="item.lessonId">
                          <tr>
                            <td style="text-align: start">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="item.lessonTitle.length > 80 ? on : ''"
                                      style="font-weight:700;max-width:200px">
                                      {{item.lessonTitle.length > 80 ? item.lessonTitle.substring(0, 77) + '...' : item.lessonTitle}}
                                    </span>
                                </template>
                                <span>{{item.lessonTitle}}</span>
                              </v-tooltip>
                            </td>
                            <td style="text-align: start">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="item.classCode.length > 30 ? on : ''"
                                      style="text-wrap: nowrap">
                                      {{item.classCode.length > 30 ? item.classCode.substring(0, 27) + '...' : item.classCode}}
                                    </span>
                                </template>
                                <span>{{item.classCode}}</span>
                              </v-tooltip>
                            </td>
                            <td>{{formatDateCus(item.lessonStartTime, 'DD/MM/YYYY HH:mm')}}</td>
                            <td>
                              <div class="d-flex flex-column justify-center" style="height: 100%;text-wrap:nowrap">
                                <div>
                                  <div v-for="(practice, index) in item.practices.slice(0, 2)" :key="practice.id" class="d-flex align-center justify-start">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                          <span
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openInNewTab(practice.lmsLinkPractice)"
                                            class="mr-1 practice-result-link"
                                            style="cursor: pointer;color:#08F;font-weight:500">
                                            {{ `Bài tập ${index + 1}:` }}
                                          </span>
                                      </template>
                                      <span>Xem đề bài</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                          <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="practice-result-link"
                                            style="cursor: pointer;color: #08F;font-weight:500"
                                            v-if="practice.time"
                                            @click="openInNewTab(practice.lmsLinkPracticeResult)"
                                          >
                                            {{ practice.noCorrect || 0 }}/{{ practice.noQuestion}}
                                          </span>
                                          <span
                                            class="practice-result-link"
                                            style="cursor: pointer;color: #EB5501;font-weight:500"
                                            v-else
                                          >
                                            Chưa làm
                                          </span>
                                      </template>
                                      <span>Xem kết quả</span>
                                    </v-tooltip>
                                  </div>
                                  <div v-if="item.practices.length > 2" class="d-flex justify-start">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="showModalHomeWork(item)"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          small
                                        >
                                          <img src="../../student_detail_bt/assets/more-icon.svg" alt="">
                                        </v-btn>
                                      </template>
                                      <span>Xem thêm</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <!-- <tr v-if="item.practices">
                            <td>
                              <span class="practice-result-link mr-1">Bài tập về nhà</span>
                              <span class="homework-icon">BTVN</span>
                            </td>
                            <td></td>
                            <td>
                              <div class="d-flex flex-column justify-center" style="height: 100%;">
                                <div>
                                  <div v-for="(practice, index) in item.practices.slice(0, 2)" :key="practice.id" class="d-flex align-center justify-center">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                          <span
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="openInNewTab(practice.lmsLinkPractice)"
                                            class="mr-1 font-weight-bold practice-result-link">
                                            {{ `BT${index + 1}${practice.time ? ':' : ''}` }}
                                          </span>
                                      </template>
                                      <span>Xem đề bài</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                          <span
                                            v-bind="attrs"
                                            v-on="on"
                                            class="practice-result-link"
                                            v-if="practice.time"
                                            @click="openInNewTab(practice.lmsLinkPracticeResult)"
                                          >
                                            {{ practice.noCorrect || 0 }}/{{ practice.noQuestion}}
                                          </span>
                                      </template>
                                      <span>Xem kết quả</span>
                                    </v-tooltip>
                                  </div>
                                  <div v-if="item.practices.length > 2">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="showModalHomeWork(item)"
                                          icon
                                          v-bind="attrs"
                                          v-on="on"
                                          small
                                        >
                                          <img src="../../student_detail_bt/assets/more-icon.svg" alt="">
                                        </v-btn>
                                      </template>
                                      <span>Xem thêm</span>
                                    </v-tooltip>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td></td>
                          </tr> -->
                          </tbody>
                        </template>
                        <tbody v-if="!items.length">
                        <tr><td colspan="4"><span style="color:red">Không có dữ liệu</span></td></tr>
                        </tbody>
                      </template>
                      <template v-slot:no-data>Không có dữ liệu</template>
                    </v-data-table>
                  </div>
                    <template v-else>
                      <div>
                        <HomeWorkTable
                          :is-loading="isLoadingHomework"
                          :homeworks="selectedProgramId === 0 ? selfStudyHomework : homeworksV2"
                          :height="isShowSortClassTutor ? 280 : 460"
                          :isSelfStudy="selectedProgramId === 0"
                          :lms-core-user-id="lmsCoreUserID"
                          @redirect-care-homework="handleRedirectCareHomework"
                          @set-date-filter="setDateFilter"
                        ></HomeWorkTable>
                      </div>
                    </template>
                </div>
                <div v-if="item.key === 'video-lesson'" id="style-2" style="max-height: 357px; overflow-y: auto; overflow-x: hidden">
                  <v-data-table
                    :headers="videoHeaders"
                    :items="listVideos"
                    :items-per-page="20"
                    class="elevation-1"
                    :hide-default-footer="true"
                    :height="isShowSortClassTutor ? '280' : ''"
                    fixed-header
                  >
                    <template v-slot:item.start_time="{ item }">
                      <span>{{ formatDateBTVN(item.start_time) }}</span>
                    </template>
                    <template v-slot:item.lesson_name="{ item }">
                      <span>{{ item.lesson_name }}</span>
                    </template>
                    <template v-slot:item.class_name="{ item }">
                      <span>{{ item.class_name }}</span>
                    </template>
                    <template v-slot:item.link_video="{ item }">
                      <a target="_blank" style=" text-decoration:none" v-bind:href="item.link_video">
                        <v-icon dense>mdi-link-variant</v-icon>
                      </a>
                    </template>
                    <template v-slot:no-data><span style="color:red">Không có dữ liệu</span></template>
                  </v-data-table>
                  <div class="paginate">
                    <div class="text" >
                      {{ `${firstNum} - ${secondNum}` }}
                    </div>
                    <v-pagination
                      v-model="currentPage"
                      :length="Math.ceil(totalListVideo/20)"
                      :total-visible="6"
                      :rows-per-page-items="[5,10,20]"
                      :rows-per-page-text="null"
                      @input="handlePagination"
                    ></v-pagination>
                  </div>
                </div>
                <div v-if="item.key === 'duet'" class="review duet">
                  <div class="review-item">
                    <div class="review-item-name col-md-4 font-weight-bold">Buổi học</div>
                    <div class="col-md-2 font-weight-bold">Link video</div>
                    <div class="col-md-2 font-weight-bold">Điểm</div>
                    <div class="col-md-2 font-weight-bold">Trạng thái</div>
                    <div class="col-md-2 font-weight-bold">Thao tác</div>
                  </div>
                  <div v-if="_.isEmpty(duets)" style="color: red">Không có buổi học nào!</div>
                  <div v-for="(item, index) in duets" :key="index" class="review-item">
                    <div class="review-item-name col-md-4">
                      <div>
                        <b>{{item.class_code}}</b><br>
                        <span>{{formatDateCustom(item.lesson_start_time)}}</span>
                      </div>
                    </div>
                    <div class="col-md-2"><a v-if="getDuetResult(item).reference_link" :href="getDuetResult(item).reference_link" target="_blank"><v-icon color="blue">mdi-download-box</v-icon></a></div>
                    <div class="col-md-2">
                      <span v-if="getDuetResult(item).correct_question">{{ getDuetResult(item).correct_question }} %</span>
                    </div>
                    <div class="col-md-2">
                      <template v-if="getDuetResult(item).tutor_learning_history_id">
                            <span v-for="(itemDuetStatus, indexDs) in confirmDuetStatusOptions" :key="'stt' + index + indexDs">
                              <span v-if="getDuetResult(item).publish === itemDuetStatus.id">{{ itemDuetStatus.title }}</span>
                            </span>
                      </template>
                    </div>
                    <div class="col-md-2">
                      <div class="d-flex" v-if="getDuetResult(item).tutor_learning_history_id && !getDuetResult(item).publish">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn icon color="#E91E63" small @click="confirmDuet(item._id, getDuetResult(item))" v-on="on">
                              <v-icon dark>mdi-share</v-icon>
                            </v-btn>
                          </template>
                          <span>Chia sẻ nhận xét</span>
                        </v-tooltip>

                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-dialog
        v-model="showListCommentStation"
        v-if="showListCommentStation"
        persistent
        max-width="1200"
        :retain-focus="false"
      >
        <ListCommentStation :listComment="listComment" :lmsCoreUserID="lmsCoreUserID" @close="showListCommentStation = false"/>
      </v-dialog>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { PRODUCT_COMBO_ORDER_TYPE, SPECIAL_ENGLISH_CODE } from "@/modules/student_care/constant/constant";
import {ORDER_RECEIPT_STATUS_MAP} from "@/modules/student_detail_bt/constant";
import HomeWorkTable from "@/components/table/homework/HomeWorkTable.vue";
import BlendedTutorTaskTab from "@/modules/student_detail_bt/components/BlendedTutorTaskTab.vue";
import {
  CLASS_ASSIGNMENT_CHANGE_REASON_OPTION,
  POPUP_DETAIL_TAB_INDEX
} from "@/modules/student_care/constant/constant";
import ContactServices from '../../../services/ContactRepository';
import { mapActions, mapGetters, mapState } from 'vuex';
import TokenService from '@/helpers/token';
import {
  SUBJECTS_SORT_CLASS, LOAI_GIAOVIEN, PACKAGE_FEE, TYPE_CALL_STATUS, TIENG_ANH, ORDER_FINISH_TYPE,
  ORDER_DEPOSIT_TYPE, ORDER_VERSION, TYPE_CURRICULUM_OBJ, SCHOOL_LEVEL,
} from '@/helpers/constant';
import * as moment from 'moment';
import ModalPeriodic from './ModalPeriodic.vue';
import ModalEditComment from './ModalEditComment.vue';
import ModalShareComment from './ModalShareComment.vue';
import ModalPeriodicIeltY from './modal-periodic-ielty/ModalPeriodicIeltY.vue';
import ModalPracticeHomework from './ModalPracticeHomework'
import StudentCareServices from "@/services/StudentCareServices";
import { PRODUCT_TRIAL_TYPE, SORT_CLASS_PROGRAMS_NAME } from "@/modules/student_care/constant/constant";
import ListCommentStation from "./modal-periodic-ielty/ListCommentStation";
import ContactRepository from "@/services/ContactRepository";
import TutorSortClassRepository from "@/services/TutorSortClassRepository";
import mapSubject from "@/mixins/mapSubject";
import OrderHistory from 'vh-sub-modules/ShareModules/src/components/OrderHistory';
const regexUrl = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const statusColor = {
  1: 'status-orange',
  2: 'status-green',
  0: 'status-gray',
};

export default {
  components: {
    HomeWorkTable,
    BlendedTutorTaskTab,
    ModalPracticeHomework,
    ModalEditComment,
    ModalShareComment,
    ModalPeriodic,
    ModalPeriodicIeltY,
    ListCommentStation,
    OrderHistory,
  },
  mixins: [mapSubject],
  props: {
    chosenSubject: {
      type: Number,
      default: () => {},
    },
    contactQuickviewDetail: {
    },
    totalListVideo:{
      type:Number
    },
    showSTT: {
      type: Boolean,
      default: true,
    },
    currentUserId: {
      type: String,
      default: '',
    },
    tab: {
      type: Number,
      default: 0,
    },
    orderList: {
      type: Array,
      default: () => [],
    },
    contactHistories: {
      type: Array,
      default: () => [],
    },
    contactNoteHistories: {
      type: Array,
      default: () => [],
    },
    tutorNoteHistory: {
      type: Array,
      default: () => [],
    },
    contactId: {
      type: Number,
      default: 0,
    },
    totalListOrder: {
      type: Array,
      default: () => [],
    },
    routineStudentId: {
      type: Number,
      default: 0,
    },
    selectedStudent: {
      type: Object,
      default: () => {},
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
    lmsCoreUserID: {
      type: Number,
      default: 0,
    },
    listVideos: {
      type: Array,
      default: () => [],
    },
    attendedStudent: {
      type: Object,
      default: () => {},
    },
    lessonByStudent: {
      type: Array,
      default: () => [],
    },
    classSelect: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      urlCRM: process.env.VUE_APP_API_ERP,
      urlERP: process.env.VUE_APP_SORT_CLASS,
      urlOMS: process.env.VUE_APP_API_OMS,
      SORT_CLASS_PROGRAMS_NAME,
      PRODUCT_COMBO_ORDER_TYPE,
      SPECIAL_ENGLISH_CODE,
      SCHOOL_LEVEL,
      TYPE_CURRICULUM_OBJ,
      changeOperatorLogTime: '',
      CLASS_ASSIGNMENT_CHANGE_REASON_OPTION,
      isLoadingHomework: false,
      currentPage:1,
      isLoading: false,
      pickTest: false,
      pickDate: false,
      note: null,
      drawn: false,
      isCancel: false,
      interviewDetailId: null,
      book: null,
      blockToShow: 2,
      regexUrl,
      PRODUCT_TRIAL_TYPE,
      ORDER_VERSION,
      SUBJECTS_SORT_CLASS,
      POPUP_DETAIL_TAB_INDEX,
      ORDER_RECEIPT_STATUS_MAP,
      LOAI_GIAOVIEN,
      PACKAGE_FEE,
      tabCare: null,
      tabStudyHistory: null,
      pagination: {
        itemsPerPage: 5,
        page: 1,
        rowsPerPage: 5,
        totalItems: 100000,
      },
      itemsCare: [
        { key: 'history-care', title: 'LỊCH SỬ CHĂM SÓC' },
        { key: 'review', title: 'NHẬN XÉT' },
        { key: 'home-work', title: 'BTVN' },
      ],
      listHistoryCare: [],
      currentCallStatus: {},
      formCreateHistoryNote: {
        note: '',
        callStatusId: 0,
      },
      callStatusRules: [
        (v) => !!v || 'Trạng thái không được để trống.',
      ],
      descriptionRules: [
        (v) => !!v || 'Mô tả không được để trống.',
      ],
      listReviewCare: [],
      homeworkHeaders: [
        {
          text: 'Buổi học', value: 'name',
        },
        {
          text: 'Lớp học', value: 'class_code',
        },
        // {
        //   text: 'Số câu đúng', value: 'score', align: 'center', sortable: false,
        // },
        {
          text: 'Thời gian', value: 'time',
        },
        {
          text: 'BTVN', value: 'practices', align: 'center',
        },
      ],
      disableSubmit: false,
      isSubmitting: false,
      TYPE_CALL_STATUS,
      monthNow: (new Date()).getMonth() + 1,
      scoreHomework: '',
      scorePeriodic: '',
      videoHeaders: [
        {
          text: 'Thời gian', value: 'start_time',
        },
        {
          text: 'Tên buổi học', value: 'lesson_name',
        },
        {
          text: 'Lớp học', value: 'class_name',
        },
        {
          text: 'Link video', value: 'link_video', align: 'center', sortable: false,
        },
      ],
      periodics: [],
      isPopupPeriodic: false,
      selectedSubjectId: 0,
      selectedProgramId: 0,
      itemReview: {},
      isEditComment: false,
      isShareComment: false,
      attrOfOthers: [
        'id',
        'lms_core_user_id',
        'subject_id',
        'name',
        'score',
        'time',
        'routine_student_id',
        'class_code',
        'lms_link_practice',
        'lms_link_practice_result',
        'no_correct',
        'no_question',
      ],
      attrOfEnglish: [
        'id',
        'lms_core_user_id',
        'subject_id',
        'name',
        'score',
        'time',
        'routine_student_id',
        'class_code',
        'lms_link_practice',
        'lms_link_practice_result',
        'speaking_score',
        'writing_score',
        'listening_score',
        'reading_score',
      ],
      otherPeriodicsHeaders: [
        {
          text: 'Tên bài tập', value: 'name',
        },
        {
          text: 'Lớp học', value: 'class_code',
        },
        {
          text: 'Điểm', value: 'get_score', align: 'center', sortable: false,
        },
        {
          text: 'Thời gian', value: 'time', align: 'center',
        },
      ],
      engPeriodicHeaders: [
        {
          text: 'Tên bài tập', value: 'name',
        },
        {
          text: 'Lớp học', value: 'class_code',
        },
        {
          text: 'Listening', value: 'listening_score', align: 'center', sortable: false,
        },
        {
          text: 'Reading', value: 'reading_score', align: 'center', sortable: false,
        },
        {
          text: 'Writing', value: 'writing_score', align: 'center', sortable: false,
        },
        {
          text: 'Speaking', value: 'speaking_score', align: 'center', sortable: false,
        },
        {
          text: 'Thời gian', value: 'time', align: 'center',
        },
      ],
      duets: [],
      confirmDuetStatusOptions: [
        {
          id: 0,
          title: 'Chưa duyệt',
        },
        {
          id: 1,
          title: 'Đã duyệt ',
        },
      ],
      ieltsy: 'ieltsy',
      statusColor,
      listLessonIeltsy: [],
      isPeriodicIeltYType: false,
      periodicType: ['cam', 'ieltsy'],
      periodicModalIeltY: false,
      isShowPeriodicScore: false,
      orderFinishType: ORDER_FINISH_TYPE,
      orderDepositType: ORDER_DEPOSIT_TYPE,
      isLoadingRightData: false,
      showListCommentStation: false,
      listComment: [],
      timeSortClass: null,
      showCountdownTime: '',
      reasonType: null,
    };
  },
  async created() {
    if (this.$store.state.typeCurriculum !== TYPE_CURRICULUM_OBJ.ONLINE) {
      this.getListStudentIeltsy();
    } else {
      this.itemsCare.push({ key: 'video-lesson', title: 'Video bài giảng' });
    }
    Bus.$on('load-right-data', async (data) => {
      this.isLoadingRightData = true;
      const params = _.cloneDeep(this.selectedStudent);
      params.subject_id = data.subjectId;
      this.selectedProgramId = data.programId;
      params.curriculum_id = this.selectedProgramId;
      this.selectedSubjectId = data.subjectId;
      this.listHistoryCare = await this.getListHistoryCare(params);
      await this.getSortClassInfo();
      if (this.isShowChangeOperatorSection || this.isShowSortClassTutor) {
        this.determineShowCareTab();
      }
      this.currentCallStatus = (this.listHistoryCare && this.listHistoryCare.length) ? this.listHistoryCare[0] : {};
      this.formCreateHistoryNote.callStatusId = this.selectedStudent.call_status_id;
      this.listReviewCare = await this.getListReviewCare(params);
      this.getListDuets();
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        await this.getListCommentStation()
        this.scoreHomework = await this.getCareHomeworkIeltsy({ subject_id: this.selectedSubjectId, lms_core_user_id: this.lmsCoreUserID, curriculum_id: this.selectedProgramId });
        const data = await this.getCarePeriodicIeltsy({ subject_id: this.selectedSubjectId, lms_core_user_id: this.lmsCoreUserID, curriculum_id: this.selectedProgramId });
        this.scorePeriodic = data.score;
        this.isShowPeriodicScore = true;
        this.isPeriodicIeltYType = this.periodicType.includes(data.type_curriculum) || false;
      } else {
      this.scoreHomework = await this.getCareHomework({ subject_id: this.selectedSubjectId, lms_core_user_id: this.lmsCoreUserID, curriculum_id: this.selectedProgramId });
        if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY && !SPECIAL_ENGLISH_CODE.includes(_.get(this.mapProgramIdAndProgram, `[${this.selectedProgramId}].code`, ''))) {
          const score = await this.getCareTestScore({lmsCoreUserId: this.lmsCoreUserID, curriculumId: this.selectedProgramId ? this.selectedProgramId : 0 });
          this.scorePeriodic = score.score;
        } else {
          const data = await this.getCarePeriodic({ subject_id: this.selectedSubjectId, lms_core_user_id: this.lmsCoreUserID, curriculum_id: this.selectedProgramId });
          this.scorePeriodic = data.score;
          this.isPeriodicIeltYType = this.periodicType.includes(data.type_curriculum) || false;
        }
        this.isShowPeriodicScore = true;
      }
      await this.getHomeworkStudent();
      this.isLoadingRightData = false;
    });
    Bus.$on('lesson-ieltsy', () => {
      this.getListStudentIeltsy();
    });

    // event mở modal share comment khi nhấn Lưu & chia sẻ với HS
    Bus.$on('open-share-comment', async (body) => {
      this.openShareComment(body);
    });
    Bus.$on('close-edit-comment', () => {
      this.closeModalEditComment();
    });
    Bus.$on('load-periodics-by-month', (data) => {
      this.getHomeworkPeriodics(data.startDayOfMonth, data.endDayOfMonth);
    });

    if (this.$store?.state?.typeCurriculum === this.ieltsy) {
      this.itemsCare.push({ key: 'duet', title: 'DUET' });
    }
  },
  beforeDestroy() {
    Bus.$off('load-periodics-by-month');
    Bus.$off('load-right-data');
    Bus.$off('open-share-comment');
    Bus.$off('close-edit-comment');
    Bus.$off('lesson-ieltsy');
  },
  watch: {
    async isShowSortClassTutor(val) {
      if (val) {
        await this.getSortClassInfo();
        this.setTimerSortClass();
      }
    },
    async isShowChangeOperatorSection(val) {
      if (val) {
        await this.getSortClassInfo();
      }
    },
    selectedProgramId(val) {
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
        this.getScoreTest().then(this.scorePeriodic);
        const currentMonth = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
        this.setDateFilter(currentMonth)
      }
    }
  },
  computed: {
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
    ...mapGetters('contact_status', ['mapCallStatus', 'mapCallTypeIdAndListCallStatus']),
    ...mapState('student_care', ['homeworks', 'homeworksV2', 'selfStudyHomework']),
    ...mapState('contact_status', ['allListStatus']),
    ...mapGetters('user', ['isTutorHomeroomTeacher', 'isStationHomeroomTeacher', 'isTutorHomeroomTeacherSecondary']),
    ...mapGetters('user', ['isLead']),
    isShowSortClassTutor() {
      return (this.mapCallStatus[this.selectedStudent.call_status_id].callType === 'TA0'
        && _.get(this.selectedStudent, 'careTagsMongo', []).some((e) => e.name === 'Chờ xếp lớp')
        && this.mapProgramIdAndProgram[this.selectedProgramId]
        && SORT_CLASS_PROGRAMS_NAME.includes(this.mapProgramIdAndProgram[this.selectedProgramId].title)
        && this.$route.query.tutorSchoolLevel === 'primary')
    },
    isShowChangeOperatorSection() {
      return (this.mapCallStatus[this.selectedStudent.call_status_id].callType === 'TA0'
        && _.get(this.selectedStudent, 'careTagsMongo', []).some((e) => e.name === 'Chuyển vận hành')
        && this.mapProgramIdAndProgram[this.selectedProgramId]
        && SORT_CLASS_PROGRAMS_NAME.includes(this.mapProgramIdAndProgram[this.selectedProgramId].title)
        && this.$route.query.tutorSchoolLevel === 'primary')
    },
    averageScore() {
      return this.selfStudyHomework.statistic ? this.selfStudyHomework.statistic.score : '0/0';
    },
    computedQuestion() {
      return this.selfStudyHomework.statistic ? this.selfStudyHomework.statistic.questions.done + '/' + this.selfStudyHomework.statistic.questions.total : '0/0';
    },
    computedScore() {
      // let [done, total] = this.scoreHomework.split('/');
      let done, total = 0
      if (this.selectedProgramId === 0) {
        if (this.selfStudyHomework && this.selfStudyHomework.statistic) {
          done = this.selfStudyHomework.statistic.homework.done;
          total = this.selfStudyHomework.statistic.homework.total;
        }
      } else {
        if (this.homeworksV2 && this.homeworksV2.selfStudy) {
          done = this.homeworksV2.selfStudy.done + this.homeworksV2.tutor.done;
          total = this.homeworksV2.selfStudy.total + this.homeworksV2.tutor.total ;
        }
      }
      return `${done || 0}/${total || 0}`;
    },
    firstNum(){
      if(this.totalListVideo > 0){
        return (this.currentPage - 1) * 20 + 1
      } else {
        return 0
      }
    },
    secondNum(){
      if(this.currentPage * 20 >= this.totalListVideo){
        return  this.totalListVideo
      } else {
        return  this.currentPage* 20
      }
    },
    checkPermissionCS() {
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY && this.checkAuthorization('tutor-student-detail-secondary-change-sale_read')) return true;
      if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.PRIMARY && this.checkAuthorization('tutor-student-detail-change-sale_read')) return true;
      return false;
    }
  },
  methods: {
    ...mapActions('student_care', [
      'getListCallStatusForHistoryCareTab',
      'createNoteInHistoryCare',
      'getListHistoryCare',
      'getDataPeriodicallyCareTable',
      'getListReviewCare',
      'getListCallStatusCount',
      'apiUpdate',
      'getCareHomework',
      'getCarePeriodic',
      'getHomeworkPeriodic',
      'getHomeworkList',
      'getHomeworkListV2',
      'getSelfStudyResult',
      'confirmDuetStatus',
      'getListLessonIeltsy',
      'getCareHomeworkIeltsy',
      'getCarePeriodicIeltsy',
      'getHomeworkListIeltsy',
      'getCareTestScore',
    ]),
    crmOrderDetailLink(item) {
      return `${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`;
    },
    determineShowCareTab() {
      if (this.listHistoryCare.length === 0) {
        this.itemsCare.splice(this.itemsCare.indexOf((e) => e.key === 'history-care'), 1);
      }
      this.itemsCare.splice(this.itemsCare.indexOf((e) => e.key === 'review'), 1);
      this.itemsCare.splice(this.itemsCare.indexOf((e) => e.key === 'homework'), 1);
      this.itemsCare.splice(this.itemsCare.indexOf((e) => e.key === 'video-lesson'), 1);
    },
    handleSortClass() {
      this.$emit('open-sort-class-popup')
    },
    formatTimeUnit(timeUnit) {
      return timeUnit < 10 ? `0${timeUnit}` : timeUnit;
    },
    countdownTime(timeDiff) {
      let dd = Math.abs(timeDiff._data.days);
      let hh = Math.abs(timeDiff._data.hours);
      let mm = Math.abs(timeDiff._data.minutes);
      let ss = Math.abs(timeDiff._data.seconds);
      hh = hh + dd * 24;
      let countdownInterval = setInterval(() => {
        if (ss === 0) {
          if (mm === 0) {
            if (hh !== 0) {
              hh -=1;
              mm = 59;
              ss = 59;
            } else {
              clearInterval(countdownInterval)
            }
          } else {
            mm -= 1;
            ss = 59;
          }
        } else {
          ss -= 1;
        }
        this.showCountdownTime = `${this.formatTimeUnit(hh)}:${this.formatTimeUnit(mm)}:${this.formatTimeUnit(ss)}`
      }, 1000)

    },
    setTimerSortClass() {
      let timeDiff = moment.duration(moment(new Date()).diff(moment(this.timeSortClass)));
      this.countdownTime(timeDiff);
    },
    async getSortClassInfo() {
      const res = await TutorSortClassRepository.getSortClassInfo(this.selectedStudent.id);
      if (res.message === 'Success') {
        this.timeSortClass = res.data.deadlineSortClass;
        this.reasonType = res.data.reasonType;
        this.changeOperatorLogTime = res.data.logTime;
        this.$emit('set-arrange-class-type', res.data.classType);
      }
    },
    handleRedirectOrder(item) {
      window.open(`${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`, '_blank');
    },
    openDetailOrder(order) {
      if (order.version === 1) {
        const routeData = `${process.env.VUE_APP_CRM}/order-detail/${order.id}?orderList=true`;
        window.open(routeData, '_blank');
      } else {
        const routeData = `${process.env.VUE_APP_CRM}/order-detail-new/${order.contactId}?order=${order.id}`;
        window.open(routeData, '_blank');
      }
    },
    openDetailOrderGroup(order) {
      const id = order.listOrders.find((item) => item.code === order.code);
      const routeData = `${process.env.VUE_APP_CRM}/order-detail/${id.id}?orderList=true`;
      window.open(routeData, '_blank');
    },
    async getListCommentStation() {
      const params = {
        lms_core_user_id: this.lmsCoreUserID,
      };
      const res = await ContactRepository.getListCommentStation(params);
      if (res && res.error) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Có lỗi xảy ra, vui lòng thử lại !',
        });
      } else {
        this.listComment = res.data;
      }
    },
    async handleRedirectCareHomework(date, item) {
      let params = {
        lms_core_user_id: this.lmsCoreUserID,
        curriculum_id: this.selectedProgramId ? this.selectedProgramId : item.curriculumId,
      }
      if (this.mapProgramIdAndProgram[this.selectedProgramId] && this.mapProgramIdAndProgram[this.selectedProgramId].code === 'CAM') {
        params.lesson_date = this.formatDateCus(date, 'YYYY-MM-DD');
      }
      const response = await StudentCareServices.getCareHomeworkReference(params);
      if (response && response.message === 'Success') {
        window.open(response.data.link, '_blank');
      }
    },
    handlePagination(page) {
      // Xử lý khi trang thay đổi
      this.currentPage = page;
      this.$emit('getListVideos',{page: page-1, limit: 20})
    },
    /* eslint-disable */
    test(pagination){
      console.log(pagination);
    },
    editAppointment(contactHistory) {
      if (
        contactHistory.action === 'APPOINTMENT'
        && contactHistory.dataId != null
      ) {
        Bus.$emit('appointment-show-form-from-appointment', {
          id: contactHistory.dataId,
        });
      }
    },
    openInNewTab(url) {
      if (url) {
        window.open(url, '_blank', 'noreferrer');
      }
    },
    async paginateHomeWorkTable() {
      await this.getHomeworkStudent();
    },
    async getHomeworkStudent() {
      this.isLoadingHomework = true;
      if (!this.lmsCoreUserID) {
        return;
      }
      let res = {};
      const params = {
        page: this.pagination.page,
        limit: this.pagination.itemsPerPage,
      };
      if (this.$store?.state?.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        params.lmsCoreUserId = this.lmsCoreUserID;
        params.subjectId = this.selectedSubjectId;
        params.curriculumId = this.selectedProgramId;
        res = await this.getHomeworkListIeltsy(params);
      } else {
        params.lms_core_user_id = this.lmsCoreUserID;
        params.subject_id = this.selectedSubjectId;
        params.curriculum_id = this.selectedProgramId;
        params.type_curriculum = this.selectedStudent.type_curriculum;
        if (this.$route.query.tutorSchoolLevel === SCHOOL_LEVEL.SECONDARY) {
          const currentMonth = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`;
          const date = this.formatStartDayAndEndDay(currentMonth);
          if (this.selectedProgramId !== 0) {
            const paramsV2 = {
              lms_core_user_id: this.lmsCoreUserID,
              subject_id: this.selectedSubjectId,
              curriculum_id: this.selectedProgramId,
              // lms_core_user_id: 1269304,
              // subject_id: 5,
              // curriculum_id: 50,
              startTime: date.startTime,
              endTime: date.endTime,
            }
            res = await this.getHomeworkListV2(paramsV2);
          } else {
            await this.getSelfStudyResult({
              // lms_core_user_id: 506704,
              lms_core_user_id: this.lmsCoreUserID,
              startTime: date.startTime,
              endTime: date.endTime,
            });
          }
        } else {
          res = await this.getHomeworkList(params);
        }
      }
      this.pagination.totalItems = res?.data?.totalItem || 0;
      this.isLoadingHomework = false;
    },
    checkTypeCs() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA - CS';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'CS';
      }
      return '';
    },
    async transferToSaleExtend() {
      this.$swal({
        title: 'Bạn có chắc muốn chuyển contact sang tab chuyển sales',
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Huỳ bỏ',
        // eslint-disable-next-line consistent-return
      }).then(async (res) => {
        this.isSubmitting = true;
        if (res.value) {
          let csCallId = 0;
          let csMoiCallStatusId = 0;
          if (this.allListStatus && this.allListStatus.length > 0) {
            for (let i = 0; i < this.allListStatus.length; i += 1) {
              if (this.allListStatus[i] && this.allListStatus[i].name === this.checkTypeCs() && this.allListStatus[i].data && this.allListStatus[i].data.length > 0) {
                for (let j = 0; j < this.allListStatus[i].data.length; j += 1) {
                  if (this.allListStatus[i].data[j] && this.allListStatus[i].data[j].code === 'MOI') {
                    csCallId = this.allListStatus[i].id;
                    csMoiCallStatusId = this.allListStatus[i].data[j].id;
                    break;
                  }
                }
              }
              if (csCallId && csMoiCallStatusId) {
                break;
              }
            }
          }
          let result = null;
          if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
            result = await this.apiUpdate({
              obj: 'routine',
              data: {
                call_id: csCallId,
                call_status_id: csMoiCallStatusId,
                type_customer_care: 3,
              },
              filters: {
                $in__id: [this.selectedStudent.id],
              },
              oldData: [{id: this.selectedStudent.id, call_id: this.selectedStudent.call_id, extend_sale_name: this.selectedStudent.extend_sale_name}],
            });
            if (result && result.message === 'Success') {
              this.closeDialog();
              await this.getDataPeriodicallyCareTable(this.filterForm);
              await this.getListCallStatusCount(this.filterForm);
              return this.$swal({
                type: 'success',
                title: 'Thành công',
                text:
                  'Chuyển contact sang tab chuyển sales thành công!!!',
              });
            }
          } else {
            result = await ContactServices.updateSale({
              ids: [this.selectedStudent.id],
            });
          }
          this.isSubmitting = false;
          if (result.message === 'Success') {
            if (this.$route.name !== 'StudentDetailTutor') {
              this.closeDialog();
              await this.getDataPeriodicallyCareTable(this.filterForm);
              await this.getListCallStatusCount(this.filterForm);
            }
            return this.$swal({
              type: 'success',
              title: 'Thành công',
              text:
                'Chuyển contact sang tab chuyển sales thành công!!!',
            });
          }
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text:
              'Có lỗi khi chuyển contact sang tab chuyển sales !!!',
          });
        }
        this.isSubmitting = false;
      });
    },
    formatDateCustom(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    async creatHistoryCareNote() {
      const user = TokenService.getUser();
      this.disableSubmit = true;
      this.formCreateHistoryNote.note = this.formCreateHistoryNote.note.trim();
      if (!this.formCreateHistoryNote.note) {
        this.formCreateHistoryNote.note = '';
        this.disableSubmit = false;
        return
      }
      const isValid = this.$refs.historyCareForm.validate();
      if (isValid) {
        const bodyRequests = {
          routine_student_id: this.routineStudentId,
          call_id: this.selectedStudent.call_id,
          call_name: this.mapCallStatus && this.mapCallStatus[this.selectedStudent.call_status_id] ? this.mapCallStatus[this.selectedStudent.call_status_id].callType : '',
          note: this.formCreateHistoryNote.note,
          subject_id: this.selectedStudent.subject_id,
          call_status_id: this.formCreateHistoryNote.callStatusId,
          call_status_name: this.mapCallStatus && this.mapCallStatus[this.formCreateHistoryNote.callStatusId] ? this.mapCallStatus[this.formCreateHistoryNote.callStatusId].callStatus : '',
          created_name: user.username,
          created_by: user.id,
          lms_core_user_id: this.selectedStudent.lms_core_user_id,
          curriculum_id: this.selectedStudent.curriculum_id,
          type_curriculum: this.selectedStudent.type_curriculum,
          type_customer_care: this.selectedStudent.type_customer_care,
        };
        const response = await this.createNoteInHistoryCare(bodyRequests);
        if (response) {
          this.selectedStudent.call_status_id = this.formCreateHistoryNote.callStatusId;
          this.formCreateHistoryNote.note = '';
          this.$refs.historyCareForm.resetValidation();
          this.formCreateHistoryNote.callStatusId = this.selectedStudent.call_status_id;
          this.listHistoryCare = await this.getListHistoryCare(this.selectedStudent);
          if (!this.itemsCare.some((e) => e.key === 'history-care')) {
            this.itemsCare.unshift({ key: 'history-care', title: 'LỊCH SỬ CHĂM SÓC' })
          }
          this.listReviewCare = await this.getListReviewCare(this.selectedStudent);
          if (this.$route.name !== 'StudentDetailTutor') {
            await this.getDataPeriodicallyCareTable(this.filterForm);
            await this.getListCallStatusCount({
              ...this.filterForm,
              callTypes: [],
              callStatuses: [],
            });
          }
          this.disableSubmit = false;
          this.$swal({
            type: 'success',
            icon: 'success',
            title: 'Tạo thành công !',
            toast: true,
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          this.disableSubmit = false;
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Tạo thất bại !',
            toast: true,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
      this.disableSubmit = false;
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex};width:fit-content;padding:0px 4px;display:flex` : '';
    },
    deleteContactHistory(contactHistory) {
      this.$emit('deleteContactHistory', contactHistory);
    },
    checkContactHistory(contactHistory) {
      if (
        contactHistory.action === 'NOTE'
        // eslint-disable-next-line radix
        && contactHistory.createdBy === parseInt(this.currentUserId)
      ) {
        return false;
      }
      return true;
    },
    showEditForm(contactHistory, index) {
      // this.editDesc = _.get(contactHistory, 'description', '');
      if (this.tab === POPUP_DETAIL_TAB_INDEX.EXCHANGE) {
        // eslint-disable-next-line no-undef
        this.$set(this.contactNoteHistories[index], 'editable', true);
      }
    },
    async updateContactHistory(contactHistory) {
      const body = {
        id: contactHistory.id,
        description: contactHistory.description,
      };
      this.$emit('updateContactHistory', body);
    },
    async clickCreateHistoryContact(schedule) {
      if (_.trim(schedule.note) === '') {
        return;
      }
      const loader = this.$loading.show();
      loader.hide();
      this.note = '';
      Bus.$emit('reload-interview');
    },
    contactInterviews() {
      // this.customerId = this.contacts.customerId;
      this.isCancel = true;
      Bus.$emit('reload-schedule-date-time');
    },
    cancelInterview(book) {
      this.$swal({
        title: 'Bạn chắc chắn hủy lịch phỏng vấn ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
      }).then(async (result) => {
        if (result.value) {
          let res;
          if (res.data.success) {
            this.$swal({
              title: 'Hủy thành công',
              type: 'success',
            }).then(() => {
              Bus.$emit('reload-interview');
            });
          } else {
            this.$swal({
              title: 'Có lỗi xảy ra',
              type: 'error',
            });
          }
        }
      });
    },
    toggleBlock() {
      if (this.blockToShow === 99) {
        this.blockToShow = 2;
      } else {
        this.blockToShow = 99;
      }
      // $('.rotate').toggleClass('down');
    },
    rePickSchedule(book) {
      this.book = book;
      this.isCancel = true;
      this.interviewDetailId = book.id;
      // if (book.operationType.value === 2) {
      //   this.pickDate = true;
      // }
      // if (book.operationType.value === 1) {
      //   this.pickTest = true;
      // }
      Bus.$emit('reload-schedule-date-time');
    },
    rePick(book) {
      // if (book.operationType.value === 1) {
      //   this.pickTest = true;
      //   if (book.status.value === this.tutorStatus.waitForSeat) {
      //     this.checkWaitStatus = true;
      //     this.$store.commit('CHECK_STATUS_QUICKVIEW', this.checkWaitStatus);
      //   }
      // }
      // if (book.operationType.value === 2) {
      //   this.pickDate = true;
      // }
      this.isCancel = false;
      this.interviewDetailId = book.id;
      this.book = book;
      this.isCancel = false;
      Bus.$emit('reload-schedule-date-time');
    },
    closeDialog() {
      Bus.$emit('closeDialog');
    },
    pickNewTest() {
      // this.pickTest = true;
      // this.book = null;
      // Bus.$emit('reset-value-test');
    },
    filterLink(link) {
      let urlLink;

      link.replace(this.regexUrl, (url) => {
        if (regexUrl.test(link)) {
          urlLink = url;
        }
      });
      return urlLink;
    },
    subjectTransfer(id) {
      let subject;
      /* eslint-disable */
      SUBJECTS_SORT_CLASS.map((s) => {
        if(s.id === id) {
          return subject = s.name
        }
      })
      /* eslint-enable */
      return subject;
    },
    typeTeacher(id) {
      let typeTeacher;
      /* eslint-disable */
      LOAI_GIAOVIEN.map((s) => {
        if(s.id === id) {
            return typeTeacher = s.name
        }
      })
      /* eslint-enable */
      return typeTeacher;
    },
    formatDateBTVN(date) {
      if (date && date !== '') {
        return moment(date).format('DD/MM/YYYY HH:mm');
      }
      return '--';
    },
    mathRound(score) {
      return (score * 10).toFixed(2);
    },
    openPopupKTDK() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) return;
      this.isPopupPeriodic = true;
      this.getHomeworkPeriodics();
    },
    async getHomeworkPeriodics(startTime = null, endTime = null) {
      const valueDate = this.convertDateTime(startTime, endTime);
      if (!this.lmsCoreUserID || !this.selectedSubjectId) {
        this.periodics = [];
        return;
      }
      const params = {
        'filters[lms_core_user_id]': this.lmsCoreUserID,
        'filters[subject_id]': this.selectedSubjectId,
        'filters[curriculum_id]': this.selectedProgramId,
        'filters[type]': 2,
        'filters[$between__lesson_start_time]': `['${valueDate.startDayOfMonth}', '${valueDate.endDayOfMonth}']`,
        attrs: (this.selectedSubjectId === TIENG_ANH && !SPECIAL_ENGLISH_CODE.includes(_.get(this.mapProgramIdAndProgram, `[${this.selectedProgramId}].code`, ''))) ? this.attrOfEnglish : this.attrOfOthers,
        'sorts[time]': 'desc',
      };
      this.periodics = await this.getHomeworkPeriodic(params);
    },
    convertDateTime(startTime, endTime) {
      const d = new Date();
      const start = new Date(d.getFullYear(), d.getMonth(), 1);
      const end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      let startDayOfMonth = '';
      let endDayOfMonth = '';

      if (startTime == null) {
        startDayOfMonth = moment(start).format('YYYY-MM-DD 00:00:00');
      } else {
        startDayOfMonth = startTime;
      }
      if (endTime == null) {
        endDayOfMonth = moment(end).format('YYYY-MM-DD 23:59:59');
      } else {
        endDayOfMonth = endTime;
      }

      return { startDayOfMonth, endDayOfMonth };
    },
    openEditComment(item) {
      this.isEditComment = true;
      this.itemReview = item;
    },
    openShareComment(item) {
      this.isShareComment = true;
      this.itemReview = item;
    },
    closeModalEditComment() {
      this.isEditComment = false;
    },
    closeModalShareComment() {
      this.isShareComment = false;
    },
    checkSubjectOfStudent(subjectId, curriculumId) {
      if (subjectId !== TIENG_ANH || SPECIAL_ENGLISH_CODE.includes(_.get(this.mapProgramIdAndProgram, `[${curriculumId}].code`, ''))) {
        return this.otherPeriodicsHeaders;
      }
      return this.engPeriodicHeaders;
    },
    async getListDuets() {
      const studentId = this.classSelect && this.classSelect.student_id ? +this.classSelect.student_id : null;
      if (studentId) {
        this.duets = await this.getListLessonIeltsy({ student_id: studentId, is_completed_duet: 1 });
      }
    },
    getDuetResult(data) {
      const dataEntry = Object.entries(data.skills);
      const res = {
        correct_question: null,
        publish: null,
        total_question: null,
        reference_link: null,
        tutor_learning_history_id: null,
        id: null,
      };
      dataEntry.forEach((item) => {
        if (item[0] === '4') {
          res.correct_question = item[1].correct_question;
          res.total_question = item[1].total_question;
          res.reference_link = item[1].reference_link;
          res.id = item[1].id;
          res.tutor_learning_history_id = item[1].tutor_learning_history_id;
          res.publish = (item[1].publish) ? item[1].publish : 0;
        }
      });

      return res;
    },
    async confirmDuet(id, params) {
      const res = await this.confirmDuetStatus({
        id,
        tutor_learning_history_id: params.tutor_learning_history_id,
      });
      if (res.success) {
        this.getListDuets();
        return this.$swal({
          type: 'success',
          title: 'Thành công!',
          text: 'Duyệt thành công!',
        });
      }

      return this.$swal({
        type: 'error',
        title: 'Lỗi!',
        text: 'Có lỗi xảy ra!',
      });
    },
    async getListStudentIeltsy() {
      const studentId = this.classSelect && this.classSelect.student_id ? +this.classSelect.student_id : null;
      if (studentId) {
        const response = await this.getListLessonIeltsy({ student_id: studentId });
        this.listLessonIeltsy = response;
      }
    },
    openPopupPeriodicIeltY() {
      if (SPECIAL_ENGLISH_CODE.includes(_.get(this.mapProgramIdAndProgram, `[${this.selectedProgramId}].code`, ''))) {
        this.openPopupKTDK();
      } else {
        this.periodicModalIeltY = true;
        // this.getHomeworkPeriodics();
      }
    },
    toOrderDetail(id) {
      if (!id) {
        return;
      }
      const routeData = `${process.env.VUE_APP_CRM}/order-detail/${id}?codeOrder=2`;
      window.open(routeData, '_blank');
    },
    showModalHomeWork(item) {
      Bus.$emit('openModalPracticeHw', item);
    },
    async getScoreTest() {
      const score = await this.getCareTestScore({ lmsCoreUserId: this.lmsCoreUserID, curriculumId: this.selectedProgramId ? this.selectedProgramId : 0 });
      if (score) {
        return score.score;
      }
      return null;
    },
    async setDateFilter(val) {
      this.isLoadingHomework = true;
      const date = this.formatStartDayAndEndDay(val);
      let res = {};
      if (this.selectedProgramId !== 0) {
        const paramsV2 = {
          lms_core_user_id: this.lmsCoreUserID,
          subject_id: this.selectedSubjectId,
          curriculum_id: this.selectedProgramId,
          // lms_core_user_id: 1269304,
          // subject_id: 5,
          // curriculum_id: 50,
          startTime: date.startTime,
          endTime: date.endTime,
        };
        res = await this.getHomeworkListV2(paramsV2);
      } else {
        await this.getSelfStudyResult({
          // lms_core_user_id: 506704,
          lms_core_user_id: this.lmsCoreUserID,
          startTime: date.startTime,
          endTime: date.endTime,
        });
      }
      this.pagination.totalItems = res?.data?.totalItem || 0;
      this.isLoadingHomework = false;
    },
    formatStartDayAndEndDay(val) {
      const input = val;
      const [year, month] = input.split('-');
      const firstDay = new Date(year, month - 1, 1);
      const firstDayFormatted = `${firstDay.getFullYear()}-${String(firstDay.getMonth() + 1).padStart(2, '0')}-${String(firstDay.getDate()).padStart(2, '0')}`;
      const lastDay = new Date(year, month, 0);
      if (new Date().getMonth() === firstDay.getMonth()) {
        lastDay.setDate(new Date().getDate());
      }
      const lastDayFormatted = `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
      return { startTime: firstDayFormatted, endTime: lastDayFormatted };
    },
    openModalListComment() {
      this.showListCommentStation = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paginate {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .text{
    font-size: 14px;
    margin-right: 20px;
  }
}
.table-layout .v-data-table__wrapper thead th {
  position: sticky;
  top: 0px;
  z-index: 97;
  background: #F7F7Fc;
}

.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.log-deposit {
  display: flex;
}
.log-deposit-info {
  display: flex;
  width: calc(100% - 85px);
  justify-content: space-between;
}
.tab-note {
  margin-bottom: 16px;
  margin-top: 10px !important;
  background: #fbfbfb;
  padding-top: 0 !important;
}

.book-calendar {
  height: 31px;
  align-items: center;
  background: #f7f7fc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.block-booking {
  .booking-time {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
  }

  .bookign-type {
    color: #bdbdbd;
    font-weight: normal;
    font-size: 10px;
    line-height: 20px;
  }
}

.table-pre {
  text-align: left;
  margin-left: 24px;
}

.tab-action-teacher {
  .v-tabs {
    margin-bottom: 30px !important;
  }
}

.showEdit {
  width: 200px;
  position: absolute;
  background: #ffffff;
  z-index: 999;
  right: 24px;
  border: 1px solid #cbd4db;
  box-shadow: 0px 10px 15px 0px #0000000f;

  .v-list-item {
    font-size: 13px;

    &:hover {
      .v-icon {
        opacity: 1;
        margin-right: 10px;
      }
    }

    .v-icon {
      margin-right: 10px;
      opacity: 0;
    }
  }
}
.icon-tab {
  object-fit: cover;
  width: 34px;
  height: 34px;
  margin-right: 8px;
}

.icon {
  margin-right: 32px;
  vertical-align: middle;
}

.down {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.table-layout .v-data-table__wrapper thead th {
  position: sticky;
  top: 0px;
  z-index: 8;
}

.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.down {
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.create-note{
  padding-top: 0!important;
}
.transfers-order {
    background: #F1F7FF;
    margin: 16px 16px 26px 32px;
    border-radius: 6px;
    padding: 12px;
    .transfers-order-name {
    color: black;
    font-weight: 700;
    text-align: left;
    span {
        color: #828282;
        }
    }
    .transfers-order-info {
        display: flex;
        width: 100%;
        text-align: left;
        .transfers-order-item {
            color: #6A2C62;
            font-weight: 700;
            width: 50%;
            span {
                color: #333333;
            }
        }
        .transfers-order-icon {
            width: 23px;
            height: 23px;
            text-align: center;
            background: #6A2C62;
        }
    }
}
.table-overflow > .v-data-table__wrapper{
  max-height: 400px!important;
  overflow: auto!important;
  table{
    padding: 0 10px;
    table-layout: fixed;
    thead tr{
      position: sticky;
      top: 0;
      background: white;
      z-index: 10;
    }
  }
}
.level-sort{
  background: linear-gradient(147.14deg, #FF3B3B 6.95%, #6600CC 93.05%);
  border-radius: 100px;
  max-width: 60px;
  width: 50px;
  height: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  white-space: nowrap;
  padding: 0 4px;
}
.care-form{
  min-width: 300px;
  background: #F7F7FC;
  border-radius: 4px;
  padding: 25px;
  .care-form-title{
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
    color: #333333;
  }
  .update-button{
    position: relative;
    bottom: 80px;
    background: #FD1F6D;
    width: 105px;
    height: 36px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    align-items: center;
    padding-top: 7px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .transfer-sales-button{
    position: relative;
    bottom: 80px;
    background: rgb(39, 174, 96);
    width: 105px;
    height: 36px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    align-items: center;
    padding-top: 7px;
    color: #FFFFFF;
    cursor: pointer;
    margin-right: 5px;
  }
  .template{
    .student-stat {
      width: 175px;
      height: 66px;
      background: #F8F8F8;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
      margin-left: 5px;
      padding: 7px;
      .frame-icon {
        width: 42px;
        height: 42px;
        background: #FFE7DA;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .title-student-stat {
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: #4F4F4F;
        margin-bottom: 6px !important;
        margin-top: 3px;
        text-align: start;
        padding-left: 25px;
      }
      .title-student-stat-result {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #4F4F4F;
        text-align: start;
        padding-left: 25px;
      }
      .label-index-result {
        font-weight: 300;
      }
    }
  }

}
.care-tab{
  .care-tab-items-view{
    max-height: 333px;
    overflow: auto;
  }
  .item-history-care {
    margin-top: 10px;
    min-height: 51px;
    background: #F7F7F7;
    padding: 5px;
    border-radius: 4px;
    .frame-icon-heart {
      width: 50px;
      height: 50px;
      background: #FFFFFF;
      border-radius: 4px;
    }
    .class-and-call-type{
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 20px;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 6px !important;
    }
    .history-care-created-at{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 11px;
      line-height: 16px;
      text-align: start;
      padding-left: 31px;
      color: #828282;
    }
    .history-care-log{
      font-style: normal;
      font-weight: 600;
      font-size: 11px;
      line-height: 16px;
      text-align: start;
      margin-top: 3px;
      margin-bottom: 6px !important;
      color: #828282;
    }
    .history-care-note{
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 16px;
      color: #2B2B2B;
      text-align: center;
      margin-top: 3px;
      margin-bottom: 0px !important;
    }
  }
}
.list-status-history{
  width: 32px;
  height: 18px;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 13px;
  text-align: center;
  padding-top: 2px;
}
.review-item {
    display: flex;
    text-align: left;
    border-bottom: 1px solid #D2D2D2;
    padding: 8px 0px;
}

.review {
    background: #F7F7FC;
    padding: 16px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
    text-align: left;
}

.review-item-name {
    display: inline-grid;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px !important;
}
.study-history{
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  .table-title{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
    color: #333333;
    text-align: start;
    margin-bottom: 8px !important;
  }
  table{
    width: 580px;
    border-radius: 4px;
    border: 1px solid #F7F7FC;
    thead{
      tr{
        background-color: #F7F7FC;
        th{
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 16px;
          color: #4F4F4F;
          text-align: start;
          height: 43px;
          padding-left: 5px;
        }
      }
    }
    tbody{
      tr{
        height: 34px;
        td{
          height: 34px;
          text-align: start;
          padding-left: 5px;
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 16px;
          color: #2B2B2B;
        }
      }
    }
  }
}
.study-history-tab{
  margin-top: 10px;
  .item-study-history{
    background: #F7F7F7;
    margin-bottom: 10px;
    padding: 5px;
    .lesson-name{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 600;
      font-size: 11px;
      line-height: 16px;
      color: #333333;
      text-align: start;
      position: relative;
      right: 10px;
    }
    .template{
      padding-bottom: 10px;
    .student-stat {
      // width: 122px;
      height: 38px;
      background: #F8F8F8;
      border: 1px solid #E0E0E0;
      border-radius: 4px;
      margin-left: 10px;
      padding: 4px;
      .frame-icon {
        width: 28px;
        height: 28px;
        background: #FFE7DA;
        border-radius: 2.30275px;
      }
      .title-student-stat {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 10px;
        color: #4F4F4F;
        margin-bottom: 0px;
        text-align: start;
        padding: 3px 0px 0px 4px;
      }
      .title-student-stat-result {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #4F4F4F;
        text-align: start;
        padding: 3px 0px 0px 4px;
      }
    }
  }
    .class-and-call-type{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 20px;
      color: #333333;
      text-align: start;
      margin-bottom: 0px;
    }
    .history-care-created-at{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 20px;
      color: #E91E63;
      text-align: start;
    }
  }
}
.no-uppercase {
  text-transform: none;
}
.point-click {
  cursor: pointer;
}
.icon-tooltip {
  position: relative;
  top: -10px;
  right: -5px;
}
.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.level-sort {
  background: linear-gradient(147.14deg, #ff3b3b 6.95%, #6600cc 93.05%);
  border-radius: 100px;
  width: 78px;
  height: 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #ffffff;
  white-space: nowrap;
  padding: 0 4px;
}
.deposit {
  background: #268a42;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  width: 65px;
  text-align: center;
}
.deposit.finished {
  background: #6a2c62;
}
.log-deposit {
  display: flex;
}
.log-deposit-status {
  width: 70px;
}
.log-deposit-info {
  display: flex;
  width: calc(100% - 85px);
  justify-content: space-between;
}
.create-finish-order-btn {
  display: inline-block;
  padding: 6px 15px;
  background: #2f80ed;
  border-radius: 3px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}
</style>
<style lang="scss">
.custom-table {
  .v-data-table__wrapper {
    max-height: 600px!important;
    overflow-y: auto!important;
    background: #fff;
    table {
      table-layout: fixed !important;
      background: #F7F7Fc!important;
    }
  }
}
.custom-table-v2 {
  .v-data-table__wrapper {
    max-height: 430px!important;
    table {
      thead {
        tr {
          th {
            &.first-table {
                background: #FBD9E9 !important;
            }
            &.second-table {
              background: #CCFFF3 !important;
            }
            &.third-table {
              background: #FBEFD9 !important;
            }
            background: #F47C7C !important;
            color: black !important;
            height: 40px !important;
            font-size: 13px !important;
            font-weight: 700 !important;
          }
        }
      }
      tbody {
        tr {
          td {
            padding: 12px 16px !important;
            background: #FFF4F4;
            border-bottom: 1px solid #E0E0E0;
          }
        }
      }
    }
  }
}
.circle-checkbox .v-input--checkbox .v-input--selection-controls__ripple {
  border-radius: 50%;
}

.circle-checkbox .v-input--checkbox .v-input--selection-controls__input {
  border-radius: 50%;
}
.checkbox-round {
  width: 1.3em;
  height: 1.3em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  transform: scale(1);
}

.checkbox-round:checked {
  background-color: green;
  border: unset;
}
.star-rating {
  .v-messages .v-messages__wrapper .v-messages__message {
    transform: translate(-106px, -11px)!important;
    white-space: nowrap!important;
  }
}
.star-rating {
  height: 40px!important;
}
.sticky-top-column {
  position: sticky;
  top: 0px;
}
.table-container {
  overflow-x: auto;
  max-width: 100%;
}

.sticky-table {
  width: max-content;
  table-layout: auto;
}
.header-cell {
  color: #333333;
  font-weight: 800;
  z-index: 97;
  background: #F7F7Fc;
}
.status-orange {
  color: orange!important;
  font-size: 24px!important;
}
.status-green {
  color: green!important;
  font-size: 24px!important;
}
.status-gray {
  color: grey!important;
  font-size: 24px!important;
}
.sticky-column {
  position: sticky;
  z-index: 1;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E0E0E0;
}
.column-header {
  font-weight: 800;
}
.receipt-status-box {
  display: flex;
  justify-content: center;
  min-width: 105px;
  color: white;
  width: fit-content;
  padding: 0px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 2;
  white-space: nowrap;
}
.receipt-status-box.success {
  background: #279600;
}
.receipt-status-box.primary {
  background-color: #184BFF !important;
}
.order-detail-box {
  padding: 12px 12px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  height: 100%;
}
</style>
